import { AppShell } from '@mantine/core';
import { Outlet, useLocation } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { GET_QUESTIONS } from '@queries/questions';
import { GET_ME } from '../queries/me';

import AppHeader from '@components/app-header';
import AppFooter from '@components/app-footer';
import LoadingData from '@components/graphql-loading-data';
import GraphqlError from '@components/graphql-error';
import TrialAccessBanner from '../components/trial-banner';
import VoyLogicIcon from '@src/assets/voylogic-icon.png';

function Home() {
  const { pathname } = useLocation();
  const isAtRootPath = pathname === '/';
  const shouldPrefetchQuestions = pathname === '/' || pathname.startsWith('/clients');

  const { data: meData } = useQuery(GET_ME, {
    skip: !isAtRootPath,
  });
  const billingStatus = String(meData?.me?.billingStatus || '').toLowerCase();
  const isTrialing = isAtRootPath && billingStatus === 'trialing';

  // get all the questions, we don't use them here, but cached for later.  Better to have the loading right after login
  const { loading, error } = useQuery(GET_QUESTIONS, {
    skip: !shouldPrefetchQuestions,
  });
  if (shouldPrefetchQuestions && loading) return <LoadingData />;
  if (shouldPrefetchQuestions && error) return <GraphqlError error={error} />;

  return (
    <AppShell layout="alt" padding="md" header={{ height: 70 }} footer={{ height: 30 }}>
      <AppShell.Header>
        <AppHeader />
      </AppShell.Header>

      <AppShell.Main bg="var(--mantine-color-gray-0)" style={{ position: 'relative' }}>
        {isAtRootPath && (
          <div
            style={{
              position: 'fixed',
              inset: 0,
              backgroundImage: `url(${VoyLogicIcon})`,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center center',
              backgroundSize: '320px 320px',
              opacity: 0.12,
              pointerEvents: 'none',
              zIndex: 0,
            }}
          />
        )}
        <div style={{ position: 'relative', zIndex: 1 }}>
          {isTrialing && <TrialAccessBanner trialEndsAt={meData?.me?.trialEndsAt} />}
          <Outlet />
        </div>
      </AppShell.Main>

      <AppShell.Footer>
        <AppFooter />
      </AppShell.Footer>
    </AppShell>
  );
}

export default Home;
